import React from 'react';
export function PrivacyFooter() {
  return <footer className="bg-midnight mt-24" data-id="element-15">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-12 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-16">
        <div className="flex items-center gap-4" data-id="element-17">
          <span className="font-serif text-2xl text-white" data-id="element-18">WinePik</span>
          <span className="text-sm text-slate-muted" data-id="element-19">
            © {new Date().getFullYear()} WinePik Pty Ltd
          </span>
        </div>
        <nav className="flex items-center gap-8 text-[15px]" data-id="element-20">
          <a href="#" className="text-slate-light hover:text-sky transition-colors" data-id="element-21">
            Home
          </a>
          <a href="#" className="text-slate-light hover:text-sky transition-colors" data-id="element-22">
            Terms
          </a>
          <a href="#" className="text-slate-light hover:text-sky transition-colors" data-id="element-23">
            Cookie Policy
          </a>
        </nav>
      </div>
    </footer>;
}